module.exports = __webpack_public_path__ + "static/media/technological-republic.743ec223.jpg";